import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import Skeleton from '../Skeleton'
import StatusFilterButton from '../Status/StatusFilterButton'

import * as S from './StatusBox.styles'
import { FilterBadge } from '../Badges'

const StatusBox = (props) => {
  const {
    titleElements = [],
    rowElements = [],
    handleClick = () => {},
    filters = [],
    removeFilter = () => {},
    variant,
    loading = false,
  } = props

  const WithSkeleton = ({ children, ...restOfProps }) => {
    return loading ? <Skeleton {...restOfProps} /> : children
  }

  return (
    <S.Container fluid>
      <S.Row>
        <S.Col lg={1} />
        <S.Col lg={3} />

        {titleElements.map((title) => {
          const selected = !!filters.find(
            (f) => f?.filterId === title?.filter?.filterId
          )

          if (title?.filter == null) {
            return (
              <S.Col key={title?.id}>
                <S.Field>{title?.label}</S.Field>
              </S.Col>
            )
          }

          return (
            <S.Col key={title?.id}>
              <FilterBadgeWrapperText
                selected={selected}
                handleClose={() => removeFilter(title?.filter)}
              >
                <StatusFilterButton
                  onClick={() => handleClick(title)}
                  label={title?.label}
                  font='quicksand'
                />
              </FilterBadgeWrapperText>
            </S.Col>
          )
        })}
      </S.Row>

      {rowElements.map((el) => {
        const selected = !!filters.find(
          (f) => f?.filterId === el?.filter?.filterId
        )

        return (
          <S.Row key={el?.id}>
            <S.Col lg={1} />
            <S.Col lg={3}>
              <FilterBadgeWrapperText
                selected={selected}
                handleClose={() => removeFilter(el?.filter)}
              >
                <StatusFilterButton
                  onClick={() => handleClick(el)}
                  label={el?.label}
                  font='quicksand'
                />
              </FilterBadgeWrapperText>
            </S.Col>

            {el.columns.map((col) => {
              const selected = !!filters.find(
                (f) => f?.filterId === col?.filter?.filterId
              )

              if (variant === 'div') {
                return (
                  <S.Col key={el?.id + col?.id}>
                    <WithSkeleton>
                      <StatusFilterButton
                        status={col?.status}
                        label={col?.label}
                        variant={variant}
                      />
                    </WithSkeleton>
                  </S.Col>
                )
              }

              return (
                <S.Col key={el?.id + col?.id}>
                  <WithSkeleton>
                    <FilterBadgeWrapper
                      selected={selected}
                      handleClose={() => removeFilter(col?.filter)}
                    >
                      <StatusFilterButton
                        onClick={() => handleClick(col)}
                        status={col?.status}
                        label={col?.label}
                        variant={variant}
                      />
                    </FilterBadgeWrapper>
                  </WithSkeleton>
                </S.Col>
              )
            })}
          </S.Row>
        )
      })}
    </S.Container>
  )
}

const PureFilterBadgeWrapper = ({
  children,
  selected = false,
  handleClose = () => {},
  isDisabled = false,
  ...restOfProps
}) => {
  if (isDisabled) return children

  return selected ? (
    <FilterBadge handleClose={handleClose} {...restOfProps}>
      {children}
    </FilterBadge>
  ) : (
    children
  )
}

const FilterBadgeWrapper = styled(PureFilterBadgeWrapper)`
  position: absolute;
  //background-color: hsl(211, 22%, 90%);
  padding: 2px 6px;
  left: 9px;

  * > span {
    color: #000;
  }
`

const FilterBadgeWrapperText = styled(FilterBadgeWrapper)`
  padding: 2px 10px;
  left: 5px;
`

StatusBox.propTypes = {
  titleElements: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.any,
    })
  ),
  rowElements: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.any,
      filterModel: PropTypes.object,
      columns: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          label: PropTypes.any,
          status: PropTypes.string,
          filter: PropTypes.shape({
            filterId: PropTypes.string.isRequired,
            label: PropTypes.any,
            filterModel: PropTypes.object,
          }),
        })
      ),
    })
  ),
  handleClick: PropTypes.func,
  filters: PropTypes.array,
  removeFilter: PropTypes.func,
  variant: PropTypes.oneOf(['button', 'link', 'anchor', 'div']),
  loading: PropTypes.bool,
}

export default StatusBox
